/*global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import {connect} from 'react-redux';
import SubmitButton from '../../components/buttons/SubmitButton/';
// import { ProjectActions } from '../actions/project';
import { ModalActions } from '../../actions/modal';
import { RelationshipTypeActions } from '../../actions/relationshipType'
import { RenameRelationshipTypeMetaPropertyActions } from '../../actions/forms/renameRelationshipTypeMetaProperty';
import {Map} from 'immutable';
// import './CreateProjectButton.css';

@connect(state => ({
  form: state.renameRelationshipTypeMetaPropForm.get('form'),
  notifications: state.renameRelationshipTypeMetaPropForm.get('notifications'),
  submitting: state.renameRelationshipTypeMetaPropForm.get('submitting'),
  relationshipTypes: state.relationshipTypes.get('relationshipTypes'),
  currentRelationshipType: state.renameRelationshipTypeMetaPropForm.get('currentRelationshipType'),
  metaKey: state.renameRelationshipTypeMetaPropForm.get('metaKey'),
  activeProp: state.renameRelationshipTypeMetaPropForm.get('activeProp'), 
  router: state.router,
}))
export default class RenameRelationshipTypeMetaPropertyModal extends Component {
  static propTypes = {
    form: PropTypes.instanceOf(Map).isRequired,
    notifications: PropTypes.instanceOf(Map).isRequired,
    submitting: PropTypes.bool.isRequired,
    relationshipTypes: PropTypes.instanceOf(Map).isRequired,
    currentRelationshipType: PropTypes.string,
    activeProp: PropTypes.string,
    router: PropTypes.object.isRequired,
  }

  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  onChange(e) {
    this.context.store.dispatch(RenameRelationshipTypeMetaPropertyActions.updateFormOnChange({
      relationshipTypeMetaPropName: this.refs.relationshipTypeMetaPropName.value,
    }));
  }

  onClose() {
    this.context.store.dispatch(ModalActions.hideModal());
  }

  dismissNotices() {
    this.context.store.dispatch(RenameRelationshipTypeMetaPropertyActions.dismissNotices());
  }

  renameRelationshipTypeMetaProperty(e) {
    e.preventDefault();

    this.props.dispatch(RelationshipTypeActions.renameRelationshipTypeMetaProperty({
      relationshipTypeId: this.props.currentRelationshipType,
      prop: this.props.activeProp,
      metaKey: this.props.metaKey,
      newMetaKey: this.refs.relationshipTypeMetaPropName.value,
    }));

  }

  onBack() {
    this.context.store.dispatch(ModalActions.backModal());
  }

  render() {
    //const propName = (this.props.form.get('relationshipTypePropName')) ? this.props.form.get('relationshipTypePropName') : this.props.activeProp;
    let propName = this.props.form.get('relationshipTypeMetaPropName');
    return (
      <div className="fs-modal-content">
        <h4>Rename Metadata Property</h4>
        {/*
        <NotificationBox notifications={this.props.notifications} type={["error", "success"]} dismiss={::this.dismissNotices} />
        */}
        <form onSubmit={this.renameRelationshipTypeMetaProperty}>
          <div className="modal-form-wrapper">
            <div className="form-group row mb-2">
              <label className="col-sm-3 col-form-label">Property Name</label>
              <div className="col-sm-9">
                <input
                  value={propName}
                  onChange={this.onChange}
                  type="text" name="relationshipTypeMetaPropName"
                  className="form-control"
                  id="relationshipTypeNameInput"
                  ref="relationshipTypeMetaPropName"
                  placeholder="Property Name"
                  autoFocus
                />
              </div>
            </div>
          </div>
          <div className="modal-form-button-wrapper">
            <SubmitButton
              className="btn btn-primary modal-submit-btn"
              submitting={this.props.submitting}
              onClick={this.renameRelationshipTypeMetaProperty}
            >Rename
            </SubmitButton>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/RenameRelationshipTypeMetaPropertyModal.js